import { Typography } from '@mui/material'
import React, { useEffect, useState, useRef } from 'react'

const Timer = ({ initialTime = 120, formatFn, onComplete, styles }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime)
  const timerRef = useRef(null)

  useEffect(() => {
    //if (initialTime === timeLeft) return

    setTimeLeft(initialTime)

    if (timerRef.current) clearInterval(timerRef.current)

    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current)
          onComplete?.()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timerRef.current)
  }, [initialTime])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = String(timeLeft % 60).padStart(2, '0')

  const text = formatFn ? formatFn({ minutes, seconds, totalSeconds: timeLeft }) : `Time Remaining: ${minutes}:${seconds}`

  return (
    <Typography
      sx={{
        fontWeight: 500,
        fontSize: '14px',
        color: '#444',
        marginBottom: '10px',
        ...styles,
      }}
    >
      {text}
    </Typography>
  )
}

export default Timer
